import {
  Box,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Get, Create } from "../../actions";
import { AutoUpdateField } from "../../components/autoUpdateField";
import ButtonWithLoading from "../../components/ButtonWithLoading";
import { DatePicker } from "../../components/DatePicker";
import { FormLoader } from "../../components/FormLoader";
import { ClassicTextEditor } from "../../components/TextEditor";
import { UploadFiles } from "../../components/Upload";
import {
  GET_AllContactList_URL,
  GET_AllUsersWithoutAuthorization_URL,
  GET_AllUsers_URL,
  Get_CircularResolutionUploadedFiles_URL,
  Get_DecisionMakers_URL,
  Get_GetCircularResolutionMembers_URL,
  Get_MCBoardMembers_URL,
  Get_MCShareholders_URL,
  Get_NotifyeeList_URL,
  Get_SingleCircularResolution_URL,
  Post_AddNewFileCircularResolution_URL,
  Post_ChangeSponsorCircularResolution_URL,
  Post_DeleteNotifyess_URL,
  Post_InsertNotifyess_URL,
  Post_SendEmailForConfirmationCircularResolution_URL,
  Post_SendEmailForConfirmation_URL,
  Post_UpdateCircularResolutionDeadline_URL,
  Post_UpdateCircularResolutionResolutionText_URL,
  Post_UpdateCircularResolutionSubject_URL,
  Post_UpdateMemberDecisionManually_URL,
} from "../../constants/apiUrls";
import { format, parseHTML } from "../../heplers/format";
import { AddPerson, Notifyee } from "./component/circularResolution/components/notifyee";
import { SelectDecisionMember } from "./component/circularResolution/components/selectDecisionMaker";
import { SelectMember } from "./component/circularResolution/components/SelectMembers";
import Card from "../../components/Card";
import { Autocomplete, ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { getTranslation } from "../../heplers/translationHelper";
import TableComponent from "../../components/table";
import { CheckCircleOutlined } from "@material-ui/icons";
const columns = [
  {
    id: "fullName",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Name", "Nom", "Name"),
  },
  {
    id: "mail",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Email", "E-mail", "Email"),
  },
  {
    id:"Type",
    label:getTranslation("Type"),
    component:({row})=><Typography>{row.representativeRole?"Board":"Shareholder"}</Typography>

  }
 
];

export const UpdateCircularResolution = () => {

  const { circularResolutionId,managementCompanyId } = useParams();
  const [circularResolution, setCircularResolution] = useState({});
  const [circularResolutionCopy, setCircularResolutionCopy] = useState({});
  const [isSubmitting, setIsSubmitting] = useState();
  const [isSubmitConfirmation, setIsSubmitConfirmation] = useState(false);
  const [enableEditing, setEnableEditing] = useState(true);
  const [contactList, setContactList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [boardList, setBoardList] = useState([]);
  const [shareList, setShareList] = useState([]);
  const [managerList, setManagerList] = useState([]);
  

  const [notifyees, setNotifyees] = useState([]);
  const [contactListLoading, setContactListLoading] = useState(false);
  const [circularResolutionMembers, setCircularResolutionMembers] = useState(
    []
  );
  const [circularResolutionFiles, setCircularResolutionFiles] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    loadCircularResolutionInfo();


    loadCircularResolutionFiles();
  }, [circularResolutionId]);
  const loadCircularResolutionInfo = () => {
    Get(
      { id: circularResolutionId },
      Get_SingleCircularResolution_URL,
      null,
      (resp) => {
        setEnableEditing(resp?.data?.status);
        setCircularResolution(resp?.data);
        setCircularResolutionCopy(resp?.data);
        if (resp?.data?.status) {
          loadDecisionMakers();
        } else if (
          resp?.data?.decisionMakerType &&
          resp?.data?.decisionMakerType == "board"
        )
          loadMCBoardMembers();
        else if (
          resp?.data?.decisionMakerType &&
          resp?.data?.decisionMakerType == "shareholder"
        )
          loadMCShareholders();
        else {
          loadMCBoardMembers();
          loadMCShareholders();
        }
      },
      (error) => {}
    );
  };

  // const loadCircularResolutionMembers = () => {
  //   Get(
  //     { id: circularResolutionId },
  //     Get_GetCircularResolutionMembers_URL,
  //     null,
  //     (resp) => {
  //       setCircularResolutionMembers(resp?.data);
  //     },
  //     (error) => {}
  //   );
  // };

    ///////////////// Board Members ////////////////////
    const loadMCBoardMembers = () => {
     
      // setMembersLoading(true);
      Get(
        { MCid: managementCompanyId },
        Get_MCBoardMembers_URL,
        null,
        (resp) => {
          // setMembersLoading(false);
          setBoardList(resp?.data);
          
        },
        (error) => {
          // setMembersLoading(false);
          enqueueSnackbar(error?.data, { variant: "error" });
        }
      );

    };

      ///////////////// Shareholder Members ////////////////////
  const loadMCShareholders = () => {

    Get(
      { MCid: managementCompanyId },
      Get_MCShareholders_URL,
      null,
      (resp) => {
        // setMembersLoading(false);
        console.log("lkjashdlkjashdlkjahd",resp.data)
        setShareList(resp?.data);

      },
      (error) => {
        // setMembersLoading(false);
        enqueueSnackbar(error?.data, { variant: "error" });
      }
    );
  };

  const loadCircularResolutionFiles = () => {
    Get(
      { CrId: circularResolutionId },
      Get_CircularResolutionUploadedFiles_URL,
      null,
      (resp) => {
        setCircularResolutionFiles(resp?.data);
      },
      (error) => {}
    );
  };

  const addNewCircularResolutionFile = (fileAddress) => {
    Create(
      { fileName: fileAddress, circularResolutionId: circularResolutionId },
      Post_AddNewFileCircularResolution_URL,
      null,
      (resp) => {
        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {}
    );
  };

  const updateSubject = (newSubject) => {
    setIsSubmitting(true);
    Create(
      { value: newSubject, circularResolutionId: circularResolutionId },
      Post_UpdateCircularResolutionSubject_URL,
      null,
      (resp) => {
        circularResolution.subject = newSubject;
        setCircularResolution({ ...circularResolution, subject: newSubject });
        setIsSubmitting(false);

        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {}
    );
  };

  const updateResolution = (newResolution) => {
    setIsSubmitting(true);

    Create(
      { value: newResolution, circularResolutionId: circularResolutionId },
      Post_UpdateCircularResolutionResolutionText_URL,
      null,
      (resp) => {
        setCircularResolution({
          ...circularResolution,
          resolution: newResolution,
        });
        setIsSubmitting(false);
        enqueueSnackbar("Resolution text updated.",{variant:"success"})
        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {}
    );
  };

  const updateDeadline = (newDeadline) => {
    setIsSubmitting(true);

    Create(
      { value: newDeadline, circularResolutionId: circularResolutionId },
      Post_UpdateCircularResolutionDeadline_URL,
      null,
      (resp) => {
        setCircularResolution({ ...circularResolution, deadline: newDeadline });
        setIsSubmitting(false);

        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {}
    );
  };

  const sendConfirmationEmail = () => {
    setIsSubmitConfirmation(true);

    Get(
      { id: circularResolutionId },
      Post_SendEmailForConfirmationCircularResolution_URL,
      null,
      (resp) => {
        enqueueSnackbar("Email sent for confirmation from sponser.", {
          variant: "success",
        });
        // setCircularResolution({...circularResolution,'deadline':newDeadline})
        setIsSubmitConfirmation(false);

        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {
        enqueueSnackbar(
          "Email not sent for confirmation from sponser. Please try again",
          { variant: "error" }
        );
      }
    );
  };

  const updateSponser = (newSponser) => {
    setIsSubmitting(true);

    Create(
      {
        newSponsorId: newSponser.id,
        circularResolutionId: circularResolutionId,
      },
      Post_ChangeSponsorCircularResolution_URL,
      null,
      (resp) => {
        // setCircularResolution({ ...circularResolution, deadline: newDeadline });
        setIsSubmitting(false);
        enqueueSnackbar("Sponsor has changed.", { variant: "info" });
        //setCircularResolutionFiles([...circularResolutionFiles,file])
      },
      (error) => {}
    );
  };

  useEffect(() => {
    setContactListLoading(true);
    Get(
      {},
      GET_AllContactList_URL,
      null,
      (resp) => {
        setContactList(resp.data);
        setContactListLoading(false);
      },
      (error) => {}
    );
  }, []);

  useEffect(() => {
    setContactListLoading(true);
    Get(
      {},
      GET_AllUsersWithoutAuthorization_URL,
      null,
      (resp) => {
        setUserList(resp.data);
        setContactListLoading(false);
      },
      (error) => {}
    );
  }, []);

// useEffect(()=>{
//   console.log("jhaksgjhasgdjhkasda",[...boardList,...shareList,...managerList])
//   setCircularResolutionMembers([...boardList,...shareList,...managerList]);
// },[boardList,shareList])

 ///////////////// Decision Makers ////////////////////
 const loadDecisionMakers = () => {
  Get(
    {
      CrId: circularResolutionId,
    },
    Get_DecisionMakers_URL,
    null,
    (resp) => {
      setCircularResolutionMembers(resp?.data);
    },
    (error) => {
      enqueueSnackbar(error?.data, { variant: "error" });
    }
  );
};

const getMembers=(decisionMakerType)=>{
  if(circularResolution.status)
    return circularResolutionMembers;
  else if (decisionMakerType == "all") return [...boardList, ...shareList];
  else if (decisionMakerType == "board") return [...boardList];
  else if(decisionMakerType == "shareholder") return [...shareList]
  else 
  return [];
}

const handleMarkDecision = (row) => {
  Create(
    { memberId: row.id },
    Post_UpdateMemberDecisionManually_URL,
    null,
    (resp) => {
      enqueueSnackbar("Manual decision marked.", { variant: "success" });
      loadDecisionMakers();
    },
    (error) => {
      enqueueSnackbar(error?.data, { variant: "error" });
    }
  );
};

  return (
    <FormLoader>
      <Card
        title={getTranslation(
          "Generate Circular Resolution",
          "Générer une résolution circulaire",
          "Kreisauflösung generieren"
        )}
      >
        {/* <CardHeader title='Details' /> */}
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                disabled
                label={getTranslation(
                  "Ceres Fee",
                  "Frais Cérès",
                  "Ceres-Gebühr"
                )}
                fullWidth
                value={circularResolution?.companyCeresServiceTitle}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <AutoUpdateField
                disabled={enableEditing}
                saving={isSubmitting}
                onUpdate={() => {
                  updateSubject(circularResolutionCopy?.subject);
                }}
                onCancel={() => {
                  setCircularResolutionCopy(circularResolution);
                }}
              >
                <TextField
                  fullWidth
                  disabled={enableEditing}
                  id="subject"
                  label={getTranslation("Subject", "Sujette", "Fach")}
                  required
                  size="small"
                  variant="outlined"
                  name="subject"
                  value={circularResolutionCopy?.subject}
                  onChange={(e) => {
                    // circularResolutionCopy.subject=e.target.value
                    setCircularResolutionCopy({
                      ...circularResolutionCopy,
                      subject: e.target.value,
                    });
                    //setCircularResolutionCopy(prev => ({ ...prev, subject: e.target.value }))
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </AutoUpdateField>
            </Grid>
            <Grid item xs={6} sm={6} md={5} lg={5}>
              <Box
                pr={1}
                pb={1}
                width="100%"
                display="flex"
                alignItems="right"
                justifyContent="align-right"
              >
                <ButtonWithLoading
                  title={getTranslation(
                    "Send Confirmation Email",
                    "Envoyer un e-mail de confirmation",
                    "Bestätigungs-E-Mail senden"
                  )}
                  size="large"
                  variant="contained"
                  loading={isSubmitConfirmation}
                  onClick={sendConfirmationEmail}
                  disabled={enableEditing}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {enableEditing === false ? (
                <ClassicTextEditor
                  title={getTranslation(
                    "Resolution",
                    "Résolution",
                    "Auflösung"
                  )}
                  disabled={enableEditing}
                  text={circularResolutionCopy?.resolution}
                  showButton
                  isSubmitting={isSubmitting}
                  onChange={(text) => {
                    updateResolution(text);
                    // setCircularResolutionCopy({
                    //   ...circularResolutionCopy,
                    //   resolution: text,
                    // });
                  }}
                />
              ) : (
                // <AutoUpdateField
                //   disabled={enableEditing}
                //   saving={isSubmitting}
                //   onUpdate={() =>
                //     updateResolution(circularResolutionCopy?.resolution)
                //   }
                //   onCancel={() => {
                //     setCircularResolutionCopy(circularResolution);
                //   }}
                // >

                // </AutoUpdateField>
                <>
                  <Typography variant="h4">Resolution:</Typography>
                  <Typography
                    style={{
                      marginTop: "20px",
                      marginBottom: "20px",
                      padding: "20px",
                      border: "1px solid grey",
                    }}
                    component="p"
                  >
                    {parseHTML(circularResolutionCopy?.resolution)}
                  </Typography>
                </>
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <TextField
                disabled
                label={getTranslation("Sponser", "Parrain", "Sponsor")}
                fullWidth
                value={circularResolution?.sponsorName}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <TextField
                fullWidth
                id="language"
                label={getTranslation("Language", "Langue", "Sprache")}
                required
                size="small"
                variant="outlined"
                name="language"
                disabled
                value={circularResolution?.language}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Autocomplete
                options={userList}
                loading={userList.length > 0}
                value={
                  circularResolution?.personIncharge
                    ? circularResolution?.personIncharge
                    : {}
                }
                getOptionLabel={(option) => option.name}
                size="small"
                // onChange={(e, value) => {

                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={getTranslation(
                      "Person Incharge",
                      "Personne en charge",
                      "Verantwortlicher"
                    )}
                    variant="outlined"
                    // error={touched.sponsorId && Boolean(errors.sponsorId)}
                    // helperText={touched.sponsorId && errors.sponsorId}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {userList.length === 0 &&
                          circularResolution?.personIncharge ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <AutoUpdateField
                saving={isSubmitting}
                onUpdate={() =>
                  updateDeadline(circularResolutionCopy?.deadline)
                }
                onCancel={() => {
                  setCircularResolutionCopy(circularResolution);
                }}
              >
                <DatePicker
                  fullWidth
                  id="deadline"
                  label={getTranslation("Deadline", "Date limite", "Termin")}
                  disabled={enableEditing}
                  value={circularResolutionCopy?.deadline}
                  onChange={(value) => {
                    setCircularResolutionCopy({
                      ...circularResolutionCopy,
                      deadline: value,
                    });
                  }}
                />
              </AutoUpdateField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card
                title={getTranslation(
                  "Decision Makers",
                  "Décideurs",
                  "Entscheidungsträger"
                )}
              >
                <CardContent>
                  <Box display="flex" justifyContent="center">
                    <ToggleButtonGroup
                      value={
                        circularResolution.decisionMakerType
                          ? circularResolution.decisionMakerType
                          : "all"
                      }
                      style={{ marginLeft: "20px" }}
                    >
                      <ToggleButton value="all">All</ToggleButton>
                      <ToggleButton value="board">Board</ToggleButton>
                      <ToggleButton value="shareholder">
                        Shareholder
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>

                  <br />
                  <br />
                  <Table>
                    <TableHead>
                      {circularResolution.status == false ? (
                        <TableRow>
                          <TableCell>
                            <Typography> Full Name</Typography>
                          </TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Type</TableCell>
                        </TableRow>
                      ) : (
                        <TableRow>
                          <TableCell>
                            <Typography> Full Name</Typography>
                          </TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Comments</TableCell>
                          <TableCell>Descision</TableCell>
                          <TableCell>Decision Date</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      )}
                    </TableHead>
                    <TableBody>
                      {getMembers(circularResolution.decisionMakerType)?.map(
                        (member) =>
                          circularResolution.status == false ? (
                            <TableRow>
                              <TableCell>{member.fullName}</TableCell>
                              <TableCell>{member.mail}</TableCell>
                              <TableCell>
                                {member.representativeRole
                                  ? "Board"
                                  : "Shareholder"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell>{member.fullName}</TableCell>
                              <TableCell>{member.mail}</TableCell>
                              <TableCell>{member.comments}</TableCell>
                              <TableCell>{format("date",member.decisionDate)=="-" ? "Pending": member.descisionText}</TableCell>
                              <TableCell>
                                {format("date", member.decisionDate)}
                              </TableCell>
                              <TableCell>
                                {member.descision === false ? (
                                  <IconButton
                                    onClick={() => handleMarkDecision(member)}
                                  >
                                    <CheckCircleOutlined />
                                  </IconButton>
                                ) : null}
                              </TableCell>
                            </TableRow>
                          )
                      )}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card
                title={getTranslation(
                  "Notifees",
                  "Notifiés",
                  "Benachrichtigungen"
                )}
              >
                <CardContent>
                  <Notifyee
                    contactList={contactList}
                    circularResolutionId={circularResolutionId}
                    disabled={circularResolution?.status}
                  />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card
                title={getTranslation(
                  "Upload Documents",
                  "Télécharger des documents",
                  "Dokumente hochladen"
                )}
              >
                <CardContent>
                  <UploadFiles
                    disabled={circularResolution?.status}
                    uploadedFiles={circularResolutionFiles}
                    onAddFile={(file) => {
                      addNewCircularResolutionFile(file);
                    }}
                    getFileName={(file) => {
                      return file.fileName;
                    }}
                    onDeleteFile={(file) => {
                      // setFieldValue(
                      //   "files",
                      //   values.files.filter(
                      //     (x) => x.fileAddress != file.fileAddress
                      //   )
                      // );
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <br />
          <br />
        </CardContent>
      </Card>
    </FormLoader>
  );
};
